<template>
    <div class="_content">
        <div class="wrap">

            <div class="c-box">

                <div class="title">
                    <div class="price">￥{{orderInfo.settlementPrice}}</div>
                    <p>申请结款金额</p>
                </div>

                <div class="item-box">
                    <div class="bottom-line">
                        <div class="key">收款账户</div>
                        <div class="val">{{orderInfo.bankAccountSecret}}</div>
                    </div>

                    <div class="">
                        <div class="key">账期</div>
                        <div class="val">{{orderInfo.billPeriod}}</div>
                    </div>
                </div>

                <div class="item-upload">

                    <div class="t">上传发票 <span v-if="!orderInfo.billFlag">（非必传）</span> </div>

                    <div class="upload" v-upload="{onUpload: upload , vin:false, index:0, refresh:true}">
                        <img v-if="!invoiceImg" src="~@/imgs/upload-bg.png" alt="">
                        <img v-else :src="invoiceImg" alt="">
                        <img v-show="invoiceImg" @click.stop="invoiceImg=''" class="uploadClose" src="~@/imgs/close.png" alt="">
                    </div>
                </div>
            </div>

            <div class="btn" @click="submit()">
                <div v-if="orderInfo.billFlag">提示：喷漆服务不上传发票可能导致结款不通过</div>
				<tt-button text="立即申请"/>
            </div>

        </div>
    </div>
</template>

<script>
import config from '@/configs/config'
import ttButton from '@/components/ttButton'

export default {
    components: {
        ttButton
    },
    data() {
        return {
            shopId: '',
            settlementId: '',
            invoiceImg: '',
            orderInfo: {}
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {

            this.shopId = tuhu.getParam('sId')

            this.settlementId = tuhu.getParam('seId')

            this.getInfo()

        },
        async getInfo() {
            
            tuhu.showIndicator()

            try {

                let data = await tuhu.fetch(`${config.apis.SETTLEMENT_ORDER_INFO}?shopId=${this.shopId}&settlementId=${this.settlementId}`)

                if (data && data.code === '200') {

					tuhu.hideIndicator()

                    this.orderInfo = data.data
                    
                } else {

					tuhu.hideIndicator()

                    console.log(`${config.apis.SETTLEMENT_ORDER_INFO}`, data)

                    tuhu.toast(data.message || '网络错误')

                }

            } catch (e) {

				tuhu.hideIndicator()

                console.log(`${config.apis.SETTLEMENT_ORDER_INFO}`, e)

            }
            
        },
        upload(val) {

			if (val && val.code === '200' && val.data) {

                this.invoiceImg = val.data

			} else {

				tuhu.toast(val.message || '网络错误')

			}
		},
        async submit() {

            if (!this.invoiceImg && this.orderInfo.billFlag) return tuhu.toast('请上传发票图片')

            tuhu.showIndicator()

            try {

                let data = await tuhu.fetch(`${config.apis.SETTLEMENT_ORDER_SUBMIT}`, {

                    method: 'post',

                    body: JSON.stringify({

                            shopId: this.shopId,

                            bankAccount: this.orderInfo.bankAccountName,

                            settlementPrice: this.orderInfo.settlementPrice,

                            shopSettlementBill: this.orderInfo.shopSettlementBill,

                            settlementId: this.orderInfo.id,

                            billImage: this.invoiceImg 

                    })

                })

                if (data && data.code === '200') {

					tuhu.hideIndicator()
                    
                    tuhu.toast(data.message || '提交成功')
                    
                    setTimeout(() => {

                        tuhu.navigateBack()

                    }, 1000)

                } else {

					tuhu.hideIndicator()

                    console.log(`${config.apis.SETTLEMENT_ORDER_SUBMIT}`, data)

                    tuhu.toast(data.message || '网络错误')

                }

            } catch (e) {

				tuhu.hideIndicator()

                console.log(`${config.apis.SETTLEMENT_ORDER_SUBMIT}`, e)

            }

        }
    }
}
</script>

<style lang="less" scoped>
._content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .wrap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .c-box {
            flex: 1;
            padding: 0 .75rem;
            .title {
                padding: .5rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 1.6rem;
                background: #fff;
                border-radius: 0.3rem;
                margin-top: .5rem;
                >div {
                    font-size: 1.8rem;
                    font-weight: bold;
                    color: #D70000;
                    line-height: 2.5rem;
                }
                >p {
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    line-height: 1rem;
                }
            }
            .item-box {
                background: #FFFFFF;
                border-radius: 0.3rem;
                padding: 0 .75rem;
                margin-top: .5rem;
                >div {
                    display: flex;
                    justify-content: space-between;
                    padding: .75rem 0;
                }
                .key {
                    color: #999;
                }
            }
            .item-upload {
                position: relative;
                margin-top: 1.4rem;
                .t {
                    font-weight: 600;
                    margin-bottom: 1rem;
                }
                .upload {
                    width: 4.5rem;
                    height: 4.5rem;
                }
                .uploadClose {
                    position: absolute;
                    top: 1.9rem;
                    left: 3.4rem;
                    height: 1.1rem;
                    width: 1.1rem;
                }
            }
        }
        .btn {
            height: 5rem;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            padding: .2rem .75rem 0 .75rem;
            >div {
                color: #D70000;
                text-align: center;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/settlementRecords/confirmInfo.vue